// Razorpay payment utility
const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const initiatePayment = async ({
  amount,
  orderId,
  customerName,
  customerEmail,
  customerPhone,
  onSuccess,
  onFailure
}) => {
  const res = await loadRazorpayScript();

  if (!res) {
    alert('Razorpay SDK failed to load. Please check your internet connection.');
    return;
  }

  const options = {
    key: RAZORPAY_KEY_ID,
    amount: amount * 100, // Convert to paise
    currency: 'INR',
    name: 'FIT-FRAME',
    description: 'Gym Photography Package',
    order_id: orderId,
    handler: function (response) {
      onSuccess(response);
    },
    prefill: {
      name: customerName,
      email: customerEmail || '',
      contact: customerPhone
    },
    theme: {
      color: '#e8ff47'
    },
    modal: {
      ondismiss: function() {
        onFailure({ error: 'Payment cancelled by user' });
      }
    }
  };

  const paymentObject = new window.Razorpay(options);
  paymentObject.open();
};

export const getPackageAmount = (packageType) => {
  const packages = {
    'starter': 1499,
    'pro': 2199,
    'transformation': 4999
  };
  return packages[packageType] || 0;
};
